import type { Author } from '../../interface/Author';
import type { Paginated } from '@/interfaces/Paginate';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getResearchAuthors = async (url: string) => {
  const { data } = await api.get<Paginated<Author>>(url);
  return data.data;
};

export const useGetResearchAuthors = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.research.authors
      : apiConfig.routes.research.authorsPublic;

  return useQuery({
    queryKey: ['entertainment', 'research', 'authors', url],
    queryFn: () => getResearchAuthors(url),
  });
};
